<template>
  <div class="header_main" v-if="survey">
    <div class="header_margin">
        <span>
            <router-link :to="{ path: '/BuildingSurvey/' + survey.buildingSurveyId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
        </span>
        <span class="header_label">Survey Name</span>
        <span class="header_value">{{ survey.surveyName}}</span>
    </div>
  </div>
</template>

<script>
import loggingService from '../services/util/loggingService'

export default {
    name: 'surveyHeader',
    props: ['survey'],
    data: function () {
        return {
            isDebug: false
        }
    },
    created () {
        loggingService.log(this.isDebug, 'surveyHeader', 'created, project: ' + this.project)
    },
    mounted () {
        loggingService.log(this.isDebug, 'surveyHeader', 'mounted, project: ' + this.project)
    }
}
</script>

<style>
    .header_main {
        padding: 10px;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #cccccc;
        border-radius: 4px;
        background-color: #f5f5f5;
    }
    .header_label {
        margin-right: 20px;
        color: #555555;
        font-weight: normal;
        font-size: 1.2em;
    }
    .header_value {
        margin-right: 20px;
        font-weight: bold;
        font-size: 1.2em;
    }
    .header_margin {
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// SurveyHeader.vue?7caa5c66